import React from 'react';
import { notificationStore } from './NotificationStore';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';

@withRouter
@observer
export class Notifications extends React.Component {
	render() {
		return (
			<div className="Notifications">
				<div className="notifications-wrapper">
					{notificationStore.notifications.map(notification => {
						return this.renderNotification(notification);
					})}
				</div>
			</div>
		);
	}

	renderNotification(notification) {
		const icons = {
			primary: '/ats/icons/check-primary-icon.svg',
			info: '/ats/icons/info-icon.svg',
			warning: '/ats/icons/warning-icon.svg',
			danger: '/ats/icons/danger-icon.svg'
		};

		return (
			<div
				className={'notification is-' + notification.type}
				ref={notification.key}
				key={notification.key}>
				<img src={icons[notification.type]} alt={notification.type} />
				<div className="notification-content">
					<h1 className="title is-5">{notification.title}</h1>
					<p>{notification.message}</p>
					{notification.action?.label &&
						(notification.action.href ? (
							<a
								className="notification-action"
								href={notification.action.href}
								target="_blank"
								rel="noopener noreferrer">
								{notification.action.label}
							</a>
						) : (
							<button
								type="button"
								className="notification-action"
								onClick={() => {
									notification.action.onClick?.();
									notificationStore.onCloseNotification(notification.key);
								}}>
								{notification.action.label}
							</button>
						))}
				</div>
				<button
					className="close-btn"
					onClick={() =>
						notificationStore.onCloseNotification(notification.key)
					}>
					<img src="/ats/icons/close-3-icon.svg" alt="close" />
				</button>
			</div>
		);
	}
}
